import {Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {Tab} from '../../interfaces/tab';
import {TabService} from '../../services/tab.service';
import {NavigationEnd, Router} from '@angular/router';
import {ROUTES} from '../../vertical-menu/vertical-menu-routes.config';
import {AuthenticationService} from '../../services/authentication.service';
import {UspreferService} from '../../services/usprefer.service';
import {UtileriasService} from '../../services/utilerias.service';


@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent implements OnInit {

  tabs = this.tabService.getTabs();
  currentUrl = '';

  constructor(private router: Router, private tabService: TabService,
              private authentication: AuthenticationService,
              private _usprefer: UspreferService,
              private utileriasService: UtileriasService) {
  }

  ngOnInit() {
    this.setPreferenceTabs();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.urlAfterRedirects;
        const path = this.getRouteInfo(this.currentUrl);

        if (this.currentUrl !== '/dashboard' && this.currentUrl !== '/administracion/perfil-usuario') {
          this.tabService.addTab(path.title, path.icon, this.currentUrl);
          this.tabs = this.tabService.getTabs();
          if (this.authentication.idUsuario !== null && this.authentication.idUsuario !== undefined) {
            this.updatePreferenceDataBase(this.tabs);
          }
        }
      }
    });
  }

  navigateTo(path: string) {
    this.router.navigateByUrl(path);
  }

  closeTab(path: string) {
    this.tabService.closeTab(path);
    this.tabs = this.tabService.getTabs();
    if (this.currentUrl === path && this.tabs.length) {
      this.router.navigateByUrl(this.tabs[this.tabs.length - 1].path);
    }
  }


  getRouteInfo(path: string): { title: string, icon: string } {
    const normalizePath = (p: string) => p.startsWith('/') ? p : '/' + p; // Asegura que las rutas relativas se conviertan en absolutas

    const findInfo = (routes: any[], targetPath: string): { title: string, icon: string } | null => {
      // Normalizamos la ruta para que siempre sea absoluta
      const normalizedPath = normalizePath(targetPath);

      for (const route of routes) {
        // Compara las rutas normalizadas
        if (normalizedPath === normalizePath(route.path) || normalizedPath.startsWith(normalizePath(route.path))) {
          if (route.submenu && route.submenu.length > 0) {
            const childInfo = findInfo(route.submenu, normalizedPath);
            return childInfo || {title: route.title, icon: route.icon};
          }
          return {title: route.title, icon: route.icon};
        }

        // Recursión para submenús
        if (route.submenu && route.submenu.length > 0) {
          const childInfo = findInfo(route.submenu, normalizedPath);
          if (childInfo) {
            return childInfo;
          }
        }
      }
      return null;
    };

    return findInfo(ROUTES, path) || {title: 'Ruta', icon: 'ft-file'};
  }


  setPreferenceTabs() {
    setTimeout(() => {

      const preferenceStorage = JSON.parse(this.utileriasService.decrypt(sessionStorage.getItem('tabs')));
      if (preferenceStorage !== undefined && preferenceStorage != null && preferenceStorage.length > 0) {
        for (const tab of preferenceStorage) {
          this.tabService.addTab(tab.title, tab.icon, tab.path);
          this.tabs = this.tabService.getTabs();
        }
      }
    }, 1000);

  }

  updatePreferenceDataBase(tabs: any): void {
    const preferenceUser = {
      idusuari: this.authentication.idUsuario,
      tabla: 'tabs',
      preferencias: JSON.stringify(tabs)
    }
    this._usprefer.postUsprefer(preferenceUser).subscribe();
  }

}
